import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGOUT_USER,
  CLEAR_AUTH_FEEDBACK,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  REFRESH_TOKEN_SUCCESS,
  SET_PRODUCTS,
  SET_ACTIVE_PID,
} from '../actions';

const INIT_STATE = {
  currentUser: {},
  forgotUserMail: '',
  newPassword: '',
  loading: false,
  error: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: '' };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        error: '',
      };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: {},
        error: action.payload.message,
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          token: action.payload.token,
          refreshToken: action.payload.refreshToken,
          expiresAt: action.payload.expiresAt,
          tokenType: action.payload.tokenType || state.currentUser.tokenType,
        },
      };
    case SET_PRODUCTS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          products: action.payload.products || [],
          productsTotal: action.payload.productsTotal || 0,
        },
      };
    case SET_ACTIVE_PID:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          pid: action.payload.pid,
          productRole: action.payload.productRole || '',
          productName: action.payload.productName || '',
        },
      };
    case FORGOT_PASSWORD:
      return {
        ...state,
        loading: true,
        error: '',
        forgotUserMail: '',
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotUserMail: 'success',
        error: '',
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        forgotUserMail: '',
        error: action.payload.message,
      };
    case RESET_PASSWORD:
      return { ...state, loading: true, error: '', newPassword: '' };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        newPassword: 'success',
        error: '',
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        newPassword: '',
        error: action.payload.message,
      };
    case CHANGE_PASSWORD:
      return { ...state, loading: true, error: '' };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case LOGOUT_USER:
      return { ...INIT_STATE };
    case CLEAR_AUTH_FEEDBACK:
      return {
        ...state,
        loading: false,
        error: '',
        forgotUserMail: '',
        newPassword: '',
      };
    default:
      return { ...state };
  }
};
